export default __webpack_public_path__ + "static/media/SFJ white.2c26b077.png";